export enum SessionRegistrationFlowEnum {
	FULL = 'full',
	WAITLIST = 'waitlist',
	AVAILABLE = 'available',
}
